import type { FaireProductEntity } from "../../entity_types/product";

export const p_pd4vqfvcsy: FaireProductEntity = {
  token: "p_pd4vqfvcsy",
  type: "product",
  name: "Massage Oil Candle – Wild Lust | Peach & Lime Leaves",
  brandToken: "b_7cc3a4bc",
  brandName: "Dame Products",
  imageUrl:
    "https://cdn.faire.com/fastly/002642e3505ebf01f841c4415381a6b81fd0b0774d792b7b64ce42f7500f1bdb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70bf1063f08764aad8920fabaf76f2f95d79b59fbe33c8af6fb0ed07f4175ecf.png",
    "https://cdn.faire.com/fastly/c66e09738c5458533be12fcaa80477c125f4ffe59973211584bc3ff9af8781eb.png",
    "https://cdn.faire.com/fastly/662d35506fbddee009884ff0dd40d39f8c4b06a06bb3093ad51809938f883171.jpeg",
    "https://cdn.faire.com/fastly/53e705f7b863dc19116c3dd8cb4cef4e4c591405efc6270827643357439f0fb1.jpeg",
    "https://cdn.faire.com/fastly/2cd7dd7ad0266e814a30f4e041e0c8f4bd3c8e61cf28625aa15992c12758cea4.jpeg",
    "https://cdn.faire.com/fastly/a21b4c46cc674acbec4f34ea9a3ac8f071b21b055ce15a445ad154af32768d90.jpeg",
    "https://cdn.faire.com/fastly/72cb97cfea016d7374c7e8b4c663e5bad32d9c85bdd076380578c694a7820998.jpeg",
  ],
  priceDollars: 21.45,
  description:
    "Ignite passion and awaken your senses with Dame’s Wild Lust Massage Oil Candle. Bursting with the vibrant energy of lime leaves, the fruity sweetness of white peach, and the sensual depth of ambrette, this intoxicating fragrance sets the mood for playful intimacy. Once lit, the candle melts into a luxurious body-safe oil enriched with jojoba oil and Vitamin E, gliding smoothly across the skin for deeply moisturizing, full-body massage. Perfect for heightening touch, preparing for intimacy, or indulging in self-love rituals, Wild Lust turns every massage into an unforgettable sensory experience.\n\nSoy-wax massage candle for full body, intimate massage\n\nIntimate area safe – melts to body-temperature oil\n\nVitamin E and jojoba oil leave skin nourished and glowing\n\nLime Leaves, Ambrette & White Peach fragrance for a playful, sensual vibe\n\nLuxurious glass pot with spout for controlled, easy pouring\n\nThe perfect sexy gift or stocking stuffer for holidays, weddings, or special nights",
  tags: [],
  msrpDollars: 39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:52:40.691Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
